@for (alert of alerts; track $index) {
  <div
    [class.alert-danger]="alert.type === alertTypes.Danger"
    [class.alert-warning]="alert.type === alertTypes.Warning"
    [class.alert-success]="alert.type === alertTypes.Success"
    class="alert alert-dismissible fade show d-flex justify-content-between align-items-center p-3 gap-3"
    role="alert"
  >
    <div class="flex-grow-1">
      <div>
        <strong class="me-1">{{ alert.title }}</strong>
        <span style="white-space: pre-line">{{ alert.text }}</span>
      </div>
      @if (alert.timestamp || alert.operationId) {
        <div class="d-flex justify-content-between text-secondary info">
          <span>
            {{ alert.timestamp | date: 'yyyy-MM-dd H:mm:ssZ' }}
          </span>
          <span class="operationId">
            {{ alert.operationId }}
          </span>
        </div>
      }
    </div>
    @if (alert.dismissable) {
      <button
        (click)="removeAlert(alert)"
        type="button"
        class="btn-close"
        data-dismiss="alert"
        aria-label="Close"
      ></button>
    }
  </div>
}
